<template>
    <div class="footer">
        <div class="page-content">
            <div class="container">
                <div class="row align-items-top">
                    <div class="col-sm-4 text-left mb-4">
                        <router-link to="/" active-class="active">Home</router-link>
                        <router-link to="/privacy" active-class="active">Privacy Policy</router-link>
                        <router-link to="/terms" active-class="active">Terms and Conditions</router-link>
                        <a href="https://livio-inc.freshdesk.com/support/home" target="_blank">Support</a>
                    </div>
                    <div class="col-sm-4 text-left mb-4">
                        <p>All work © Livio 2019<p>
                        <p>332 E Lincoln Ave.<br/>
                        Royal Oak, MI 48067</p>
                    </div>
                    <div class="col-sm-4 text-left">
                        <router-link to="/download/ios"><img src="../../../static/assets/images/logos/1x/appstore_icon.png" srcset="../../../static/assets/images/logos/2x/appstore_icon@2x.png 2x, ../../../static/assets/images/logos/3x/appstore_icon@3x.png 3x"/></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
        };
    }
}
</script>


// WEBPACK FOOTER //
// FooterAlt.vue?0d1b7cec